// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxxxlargeOnWide-superElipse-5fdf6bd2","strokeWidth":"super-ellipse-skins-xxxxlargeOnWide-strokeWidth-a9861102"};